
const user = {

    namespaced: true,

    state: () => ({
        user: null,
        defaultLanguage: process.env.VUE_APP_DEFAULT_LANGUAGE,
        token: null,
        TwoFA: null
    }),

    mutations: {
        setToken: (state, token) => {
            state.token = token
        },
        setUser: (state, user) => {
            state.user = user
        },

        set2FA: (state, user) => {
            state.TwoFA = user
        },
        setDefaultLanguage: (state, language) => {
            state.defaultLanguage = language
        }
    },

    actions: {

        setUserSession: (context, { user, token }) => {

            return new Promise((success) => {

                if (user && token) {
                    context.commit('setToken', token)
                    context.commit('setUser', user)
                    context.commit('setDefaultLanguage', user.language)
                    success()
                }
            })
        },

        setUser2FA: (context, { userInfo, token }) => {            
            return new Promise((success) => {
                if (user) {
                    context.commit('set2FA', userInfo)
                    context.commit('setToken', token)
                    success()
                }
            })
        },

        removeUser2FA: (context, user) => {
            return new Promise((success) => {
                if (user) {
                    context.commit('set2FA', null)
                    context.commit('setToken', null)
                    success()
                }
            })
        },

        setLanguage: (context, language) => {
            return new Promise((success) => {
                const lang = language == 'ar' ? 'ar' : 'en'
                context.commit('setDefaultLanguage', lang)

                success()
            })
        },

        removeUserSession: (context) => {

            return new Promise((success) => {
                context.commit('setToken', null)
                context.commit('setUser', null)
                success()
            })

        }
    },

    getters: {
        isAuthenticated(state) {
            return state.token && state.user
        },

        loggedInUser: state => {
            return state.user
        },

        token: state => {
            return state.token || null
        },

        TwoFA: state => {
            return state.TwoFA || null
        },
        language: state => {
            return state.defaultLanguage
        },

    }
}

export default user